import { ChartData } from '../../../shared/types/game.types';

/**
 * 서버 데이터를 차트 데이터로 변환
 * 원본 데이터를 그대로 사용 (과거 데이터는 당시의 호가 단위 규칙을 따름)
 */
export const convertServerDataToChartData = (
  serverData: any[]
): ChartData[] => {
  console.log('🔄 서버 데이터를 차트 데이터로 변환 시작...');
  console.log('📋 서버 데이터 개수:', serverData.length);
  console.log(
    '📋 첫 번째 아이템 원본:',
    JSON.stringify(serverData[0], null, 2)
  );
  console.log('📋 첫 번째 아이템 필드명:', Object.keys(serverData[0] || {}));

  const cachedChartData = serverData
    .map((item: any, index: number) => {
      if (!item) {
        console.warn(`⚠️ [${index}] 빈 아이템 발견:`, item);
        return null;
      }

      // 필드명 확인 (snake_case도 확인)
      const hasTradingDate =
        item.tradingDate !== undefined || item.trading_date !== undefined;
      const hasOpenPrice =
        item.openPrice !== undefined || item.open_price !== undefined;
      const hasClosePrice =
        item.closePrice !== undefined || item.close_price !== undefined;
      const hasHighPrice =
        item.highPrice !== undefined || item.high_price !== undefined;
      const hasLowPrice =
        item.lowPrice !== undefined || item.low_price !== undefined;
      const hasVolume = item.volume !== undefined;

      if (index === 0) {
        console.log('📋 [0] 필드 확인:', {
          tradingDate: item.tradingDate || item.trading_date,
          openPrice: item.openPrice || item.open_price,
          closePrice: item.closePrice || item.close_price,
          highPrice: item.highPrice || item.high_price,
          lowPrice: item.lowPrice || item.low_price,
          volume: item.volume,
        });
      }

      if (
        !hasTradingDate ||
        !hasOpenPrice ||
        !hasClosePrice ||
        !hasHighPrice ||
        !hasLowPrice
      ) {
        console.error(`❌ [${index}] 필수 필드 누락:`, {
          tradingDate: hasTradingDate,
          openPrice: hasOpenPrice,
          closePrice: hasClosePrice,
          highPrice: hasHighPrice,
          lowPrice: hasLowPrice,
          volume: hasVolume,
          itemKeys: Object.keys(item),
        });
        return null;
      }

      // 필드명 매핑 (camelCase 또는 snake_case 지원)
      const tradingDateStr = item.tradingDate || item.trading_date;
      const openPriceStr = item.openPrice || item.open_price;
      const highPriceStr = item.highPrice || item.high_price;
      const lowPriceStr = item.lowPrice || item.low_price;
      const closePriceStr = item.closePrice || item.close_price;
      const volumeStr = item.volume;

      const tradingDate = new Date(tradingDateStr);
      if (isNaN(tradingDate.getTime())) {
        console.warn(`⚠️ [${index}] 유효하지 않은 날짜:`, tradingDateStr);
        return null;
      }
      const timestamp = tradingDate.getTime();

      // 문자열을 숫자로 변환 (bigint 문자열 처리)
      // 원본 데이터를 그대로 사용 (과거 데이터는 당시의 호가 단위 규칙을 따름)
      const open = parseInt(openPriceStr, 10);
      const high = parseInt(highPriceStr, 10);
      const low = parseInt(lowPriceStr, 10);
      const close = parseInt(closePriceStr, 10);
      const volume = volumeStr ? parseInt(volumeStr, 10) : 0;

      if (isNaN(open) || isNaN(high) || isNaN(low) || isNaN(close)) {
        console.error(`❌ [${index}] 유효하지 않은 가격 데이터:`, {
          openPriceStr,
          highPriceStr,
          lowPriceStr,
          closePriceStr,
          parsed: { open, high, low, close },
          originalItem: item,
        });
        return null;
      }

      // 값 검증
      if (open <= 0 || high <= 0 || low <= 0 || close <= 0) {
        console.error(`❌ [${index}] 가격이 0 이하:`, {
          open,
          high,
          low,
          close,
        });
        return null;
      }

      // high와 low가 open과 close 범위 내에 있도록 보정
      const adjustedHigh = Math.max(high, open, close);
      const adjustedLow = Math.min(low, open, close);

      const chartItem: ChartData = {
        timestamp,
        open,
        high: adjustedHigh,
        low: adjustedLow,
        close,
        volume: volume || 0,
        change: close - open,
        changePercent: open !== 0 ? ((close - open) / open) * 100 : 0,
        time: tradingDate.toLocaleDateString(),
        isUp: close >= open,
      };

      if (index === 0 || index === 1 || index === serverData.length - 1) {
        console.log(`✅ [${index}] 캔들 변환 완료:`, {
          timestamp,
          open,
          high,
          low,
          close,
          volume,
          original: {
            tradingDate: tradingDateStr,
            openPrice: openPriceStr,
            highPrice: highPriceStr,
            lowPrice: lowPriceStr,
            closePrice: closePriceStr,
          },
        });
      }

      return chartItem;
    })
    .filter((item): item is ChartData => item !== null)
    .sort((a: ChartData, b: ChartData) => a.timestamp - b.timestamp);

  console.log('📊 변환된 차트 데이터 개수:', cachedChartData.length);

  if (cachedChartData.length > 0) {
    console.log('📊 변환된 첫 번째 캔들:', cachedChartData[0]);
    console.log(
      '📊 변환된 마지막 캔들:',
      cachedChartData[cachedChartData.length - 1]
    );
  }

  return cachedChartData;
};
